<template>
<div class="d-flex align-items-center">

  <el-form :inline="true" class="d-inline-flex"
    label-position="left" label-width="30%">

    <el-form-item :label="$t('AccountSelector.Distributor')" v-if="user.type === 'gaa'">
      <el-select v-model="siId" placeholder="Select" size="small" @change="applySi">
        <el-option v-for="si in displaySisData"
          :key="si.id" :label="si.name" :value="si.id">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="EAA" v-if="user.type === 'gaa' || user.type === 'si'">
      <el-select v-model="eaaId" placeholder="Select" size="small" @change="applyEaa">
        <el-option v-for="eaa in filteredEaas"
          :key="eaa.id" :label="eaa.name" :value="eaa.id">
        </el-option>
      </el-select>
    </el-form-item>

    <!-- <el-form-item label="店家" v-if="shopEnabled && user.type === 'eaa'">
      <el-select v-model="shopId" placeholder="（店家）" size="small" @change="applyShop">
        <el-option v-for="shop in filteredShops"
          :key="shop.id" :label="shop.name" :value="shop.id">
        </el-option>
      </el-select>
    </el-form-item> -->

    <el-form-item :label="$t('AccountSelector.Store')" v-if="shopEnabled">
      <el-select v-model="shopId" filterable size="small"
        :placeholder="`(${$t('AccountSelector.Keyword_Search')})`" @change="applyShop"
        :remote-method="suggestShops" :loading="false">
        <el-option v-for="shop in suggestedShops"
          :key="shop.id" :label="shop.name" :value="shop.id">
        </el-option>
      </el-select>
      <!-- <el-autocomplete v-model="shopId" :fetch-suggestions="suggestShops" placeholder="（店家）"
        @select="applyShop">
      </el-autocomplete> -->
    </el-form-item>

  </el-form>
  
</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'account-selector',
  props: {
    user: Object,
    shopEnabled: {
      type: Boolean, default: true
    }
  },

  mounted() {
    console.log('[ACCOUNT-SELECTOR] user', this.user);
    if (this.user.type === 'gaa') {
      this.fetchSis();
      this.fetchEaas();
    }
    else if (this.user.type === 'si') {
      this.fetchEaas();
    }

    if (this.shopEnabled)
      this.fetchShops();
  },

  methods: {
    fetchSis() {
      axios.get(`${process.env.VUE_APP_APIHOST}/${this.user.type}/si-accounts`)
      .then(response => {
        // console.log('[ACCOUNT-SELECTOR] got SIs', response.data);
        this.sis = [...response.data]
      })
      .catch(err => {
        console.error(`Cannot fetch SI account list`, err);
      });
    },
    fetchEaas() {
      axios.get(`${process.env.VUE_APP_APIHOST}/${this.user.type}/eaa-accounts`)
      .then(response => {
        // console.log('[ACCOUNT-SELECTOR] got EAAs', response.data);
        this.eaas = response.data;
      })
      .catch(err => {
        console.error(`Cannot fetch EAA account list`, err);
      });
    },
    fetchShops() {
      axios.get(`${process.env.VUE_APP_APIHOST}/${this.user.type}/shops`)
      .then(response => {
        // console.log('[ACCOUNT-SELECTOR] got shops', response.data);
        if (Array.isArray(response.data)) {
          this.shops = response.data;
        }
        else {//NOTE: Probably in EAA mode.
          this.shops = response.data.shops;
          // Fill property 'id' in case of missing.
          this.shops.forEach(s => {
            if (s.id === undefined || s.id === null) s.id = s.accountId;
          })
        }

        this.suggestShops('', ret => {});//Re-populate suggested shop list for auto-complete input.
      })
      .catch(err => {
        console.error(`Cannot fetch shops`, err);
      });
    },

    // suggestShops(keyword, cb) {//NOTE: For auto-completion
    //   let ret = [];
    //   this.filteredShops.forEach(shop => {
    //     if (shop.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1)
    //       ret.push({value: shop.name});
    //   });
    //   cb(ret);
    // },
    suggestShops(keyword) {//NOTE: For auto-completion
      // console.log('suggestShops', keyword);
      this.suggestedShops = [];
      this.filteredShops.forEach(shop => {
        if (!keyword.length || shop.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1)
          this.suggestedShops.push(shop);
      });
    },

    applySi() {
      if (this.siId === 0) {
        this.eaaId = 0;
      }
      this.shopId = undefined;
      // this.suggestedShops = [];
      //Re-populate suggested shop list for auto-complete input.
      this.suggestShops('', ret => {});
      this.$emit('apply-account', {id: this.siId}, {id: this.eaaId}, undefined);
    },
    applyEaa() {
      // if (this.eaaId === 0) 
      this.shopId = undefined;
      // this.suggestedShops = []
      //Re-populate suggested shop list for auto-complete input.
      this.suggestShops('', ret => {});
      this.$emit('apply-account', {id: this.siId}, {id: this.eaaId}, undefined);
    },
    applyShop() {
      console.log('applyShop', this.shopId);
      this.$emit(
        'apply-account',
        {id: this.siId},
        {id: this.eaaId},
        this.shops.find(shop => {return shop.id === this.shopId;}) //Is undefined if no selected shop.
      );
    }
  },

  data() {
    return {
      siId: this.user.type === 'si'? this.user.id: 0,
      eaaId: this.user.type === 'eaa'? this.user.id: 0,
      shopId: undefined,
      sis: [],
      eaas: [],
      shops: [],

      suggestedShops: []
    };
  },

  computed: {
    displaySisData() {
      const copySisData = [...this.sis];
      copySisData.unshift({id: 0, name: `(${this.$t('AccountSelector.All')})` })
      return copySisData
    },
    filteredEaas() {
      let ret = [{id: 0, name: `(${this.$t('AccountSelector.All')})` }];
      Array.prototype.push.apply(
        ret,
        this.eaas.filter(eaa => eaa.siId === this.siId)
      );
      // eslint-disable-next-line
      this.eaaId = 0;//Reset selection to 0.
      return ret;
    },

    filteredShops() {
      // console.log(`[ACCOUNT-SELECTOR] Filtering shops for ${this.siId} / ${this.eaaId}`);
      let ret = [{id: 0, name: `(${this.$t('AccountSelector.Please_Select_A_Store')})`}];
      if (this.user.type === 'eaa') {
        return ret.concat(this.shops);
      }
        
      let eaaId = this.eaaId, siId = this.siId;
      Array.prototype.push.apply(
        ret,
        this.shops.filter(shop => {
          if (eaaId > 0) return shop.eaaId === eaaId;
          if (siId > 0) return shop.siId === siId;
          return true;
        })
      );
      // eslint-disable-next-line
      this.shopId = undefined;//Reset selection to 0.
      return ret;
    }
  }
};
</script>

<style scoped>
.el-form-item {
  margin-bottom: 0;
}

.d-inline-flex {
  flex-direction: column;
}
</style>